export default {
  namespaced: true,
  state:{    
    clients: [],    
    clientCreate: {
      modal: false,
      values: {}
    },
    clientEdit: {
      modal: false,
      values: {}
    },
    uploadClients: {
      modal: false
    }
  },
  getters:{
    clients(state){
      return state.clients;
    },   
    clientCreate(state) {
        return state.clientCreate;
    },
    uploadClients(state) {
      return state.uploadClients;
    },
    clientEdit(state) {
      return state.clientEdit;
    }
  },
  mutations:{
    SET_CLIENTS(state, values){
      state.clients = values;
    },
    SET_CLIENT_CREATE_MODAL(state, value) {
      state.clientCreate.modal = value;
    },
    SET_CLIENT_CREATE_VALUES(state, value) {
      state.clientCreate.values = value;
    },
    SET_UPLOAD_CLIENTS_MODAL(state, value) {
      state.uploadClients.modal = value;
    },
    SET_CLIENT_EDIT_MODAL(state, value) {
      state.clientEdit.modal = value;
    },
    SET_CLIENT_EDIT_VALUES(state, value) {
      state.clientEdit.values = value;
    },
    PUSH_CLIENT(state, value){
      state.clients.push(value);
    },    
    SET_UPDATE_CLIENT(state, values){
      var editedIndex = state.clients.map(client => client.id).indexOf(values.id);      
      if (editedIndex > -1){
        Object.assign(state.clients[editedIndex], values);              
      }
      return;
    },
    SPLICE_CLIENT(state, value){
      let i = state.clients.map(client => client.id).indexOf(value);      
      state.clients.splice(i, 1);
    }
  },
  actions:{
    getClients({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/clients').then((response) => {
          commit('SET_CLIENTS', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    clientStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/clients', formData).then((response) => {
          commit('PUSH_CLIENT', response.data.data);          
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    uploadClients({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/clients/upload', formData).then((response) => {          
          commit('SET_CLIENTS', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    clientUpdate({commit}, payload) {
      var value = payload.id;            
      return new Promise((resolve, reject) => {
        axios.put('admin/clients/' + value, payload).then((response) => {          
          commit('SET_UPDATE_CLIENT', response.data.data);
          resolve(response);   
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteClient({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/clients/' + value).then((response) => {
          commit('SPLICE_CLIENT', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });      
    },
  }
}
